import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ContentState } from 'src/app/store/state/content.state';
import { RequestUtil } from 'src/app/utils/request.util';
import { setTitleComponent } from 'src/app/utils/titles.util';
import { SUPPORT4U_URL} from '../../app.constants';

@Component({
    selector: 'u4-cpp-support4u',
    template: ''
})
export class Support4UComponent implements OnInit {
    public labels: {[key: string]: string};  
    private destroy$: Subject<void> = new Subject<void>();

    constructor(
        private store: Store<ContentState>,
        private requestUtil: RequestUtil,
        private titleService: Title
    ) {
        this.store.select(state => state.labels).pipe(
            takeUntil(this.destroy$)
        ).subscribe(labels => {
            this.labels = labels;
            this.titleService.setTitle(setTitleComponent(this.labels['support4u.title']));
        });
    }

    ngOnInit() {
        window.location.href = SUPPORT4U_URL;
    }
}
